let  rootHistory = undefined;
export function setRootHistory(history) {
    rootHistory = history;
}

export function getRootHistory() {
    return rootHistory;
}